/* MolCellQuest — Firebase の設定値
   ──────────────────────────────────────────────────────────
   ここは「設定を置くだけ」のファイル。SDK の読み込みと初期化は
   firebase-sync.js が担当し、CDN（gstatic）から動的 import する。
   npm の firebase パッケージには依存しないので、
   `import ... from "firebase/app"` を書いてはいけない。

   オフライン専用で動かしたいときは apiKey を "YOUR_API_KEY" に戻す。
   firebase-sync.js が未設定とみなして同期を自動で無効化する。
   ────────────────────────────────────────────────────────── */

window.FIREBASE_CONFIG = {
  apiKey: "AIzaSyA4CIWu1mcqMKO_h7BLUp_CQRsMq1rmpQo",
  authDomain: "molcellquest.firebaseapp.com",
  projectId: "molcellquest",
  storageBucket: "molcellquest.firebasestorage.app",
  messagingSenderId: "760719783144",
  appId: "1:760719783144:web:add04e11913778aab3c55d",
  measurementId: "G-D2VCJTZB9N",
};
